import { render } from "./AuthorDetail.vue?vue&type=template&id=c4e76062"
import script from "./AuthorDetail.vue?vue&type=script&lang=js"
export * from "./AuthorDetail.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__